import React from 'react'
import { createRoot } from 'react-dom/client'
import {
  HashRouter,
} from 'react-router-dom'
import 'babel-polyfill'
import '@roo/roo/theme/default/index.css'
import '@/assets/styles/index.less'
import '@/assets/styles/roo0119.scss'
import initI18n, { isRtl }  from '@/common/utils/i18n'

import { RecoilRoot } from 'recoil'
import AppRoutes from '@/router'
import AppLayout from './components/AppLayout'
import { getRegion } from './common/utils/i18nFuncs'
import { setCompassRegion } from  '@sailor/compass'
import { ConfigProvider } from '@roo/roo'


`
  开发环境下, roo 很多组件由于不符合 react 规范导致报错，暂时忽略
  https://github.com/plouc/nivo/issues/2415
`
if (process.env.AWP_DEPLOY_ENV !== 'production') {
  const originalError = console.error
  console.error = (...args) => {
    const errInfo = args[0]
    if (typeof errInfo === 'string') {
      if (errInfo.includes(
        'Support for defaultProps will be removed from function components in a future major release.',
      )) {
        return
      }
      if (errInfo.startsWith('Warning: Roo')) {
        return
      }
    }

    originalError(...args)
  }
}

function App () {
  return (
    <ConfigProvider config={{ direction: isRtl ? 'RTL' : 'LTR'  }}>
      <RecoilRoot>
        <HashRouter>
          <AppLayout >
            <AppRoutes/>
          </AppLayout >
        </HashRouter>
      </RecoilRoot>
    </ConfigProvider>
  )
}

setCompassRegion(getRegion())

initI18n(() => {
  const container = document.getElementById('root') as HTMLElement
  createRoot(container).render(<App />)
})